import { CircularProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Formik, Form } from 'formik';
import React from 'react';
import DialogTitle from 'v2/components/Shared/DialogTitle';
import NewCard from 'v2/components/Shared/SelectCreditCard/newCard';
import CardSchema from 'v2/components/Shared/SelectCreditCard/validations';

import { useStyles } from './styles';
import Transition from './transition';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (...args: any[]) => void;
}

const AddPaymentMethodDialog = ({ isOpen, onClose, onSubmit }: IProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();

  return (
    <Formik validationSchema={CardSchema} initialValues={{ number: '', name: '', expiry: '', cvc: '' }} onSubmit={onSubmit}>
      {({ dirty, isValid, isSubmitting, submitForm, resetForm }) => (
        <Form>
          <Dialog
            TransitionComponent={Transition}
            aria-labelledby='customized-dialog-title'
            open={isOpen}
            fullWidth={true}
            maxWidth='md'
            fullScreen={fullScreen}
          >
            <DialogTitle
              id='customized-dialog-title'
              onClose={() => {
                resetForm();
                onClose();
              }}
            >
              <Typography variant='h6'>Adicionar nova forma de pagamento</Typography>
            </DialogTitle>
            <DialogContent className={classes.dialogContent} dividers>
              <NewCard />
            </DialogContent>
            <DialogActions disableSpacing={false}>
              <div>
                <Button
                  id='add-payment-method-dialog-back-button'
                  onClick={() => {
                    resetForm();
                    onClose();
                  }}
                  className={classes.button}
                >
                  Voltar
                </Button>
                <Button
                  id='add-payment-method-dialog-save-button'
                  onClick={submitForm}
                  type='submit'
                  disabled={!dirty || !isValid || isSubmitting}
                  color='secondary'
                  variant='contained'
                  className={classes.button}
                >
                  {isSubmitting && <CircularProgress size={10} style={{ color: '#192542', marginRight: 10 }} />}
                  Salvar Novo Cartão
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        </Form>
      )}
    </Formik>
  );
};

export default AddPaymentMethodDialog;
